import { slideUp, slideDown } from 'es6-slide-up-down';

export default class AreaSlideUpDown {
  constructor (clickedSlideUpDownElem, slideUpDownElem) {
    this.slideUpDownElem = slideUpDownElem;

    clickedSlideUpDownElem.addEventListener('click', this.addOpenAndCloeSlideEvent.bind(this));
  }

  addOpenAndCloeSlideEvent (event) {
    event.preventDefault();
    const slideDownAnimationMilliSecond = 400;

    if (this.slideUpDownElem.classList.contains('js-event-open')) {
      this.slideUpDownElem.classList.add('js-event-close');
      this.slideUpDownElem.classList.remove('js-event-open');
      slideDown(this.slideUpDownElem, {
        duration: slideDownAnimationMilliSecond
      });
    } else {
      this.slideUpDownElem.classList.add('js-event-open');
      this.slideUpDownElem.classList.remove('js-event-close');
      slideUp(this.slideUpDownElem, {
        duration: slideDownAnimationMilliSecond
      });
    }
  }
}
